import { closeAllOverlayInstances } from "@shared/ui/chakra/overlays/close-all-overlay-instances";

import { otpOverlay } from "./ui/otp-overlay";
import { securityOverlay } from "./ui/security-overlay";
import { totpOverlay } from "./ui/totp-overlay";
import { transactionVerifyOverlay } from "./ui/transaction-verify-overlay";

const twoFaOverlays = [
  securityOverlay,
  otpOverlay,
  totpOverlay,
  transactionVerifyOverlay,
] as const;

export const closeAllTwoFaOverlays = () => {
  twoFaOverlays.forEach(closeAllOverlayInstances);
};
